module.exports = __webpack_public_path__ + "static/img/2.968433d.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/2.png
// module id = QO7o
// module chunks = 1